module.exports = __webpack_public_path__ + "static/media/webdesign-services-img45.966cf2d7.jpg";